import { ReferenceInput, required, SelectInput } from "react-admin";
import { useField } from "react-final-form";

const WaveInput = () => {
  const schoolInput = useField("schoolId");
  const routeInput = useField("routeIds");
  const parentsInput = useField("parentIds");
  const driversInput = useField("driverIds");
  const busAssistantInput = useField("busAssistantIds");

  const reset = () => {
    routeInput.input.onChange([]);
    parentsInput.input.onChange([]);
    driversInput.input.onChange([]);
    busAssistantInput.input.onChange([]);
  };

  return (
    <ReferenceInput
      label="Select Wave"
      source="busScheduleId"
      reference="busSchedules"
      filter={{ SchoolId: Number(schoolInput.input.value), HasRoutePlan: true }}
      sort={{ field: "name", order: "ASC" }}
      onChange={reset}
      perPage={9999}
      validate={required()}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default WaveInput;
